class SupplierService {
  constructor () {
    this.user = window.user;
  }

  getUser () {
    return this.user;
  }

  hasAuthority (privilege) {
    return this.user.hasAuthority(privilege);
  }

  getSupplierName () {
    return this.getUser().name;
  }

  getCurrentAccountName () {
    return this.getUser().currentAccountName;
  }

  getSupplierUserEmail () {
    return this.getUser().supplierUserEmail;
  }

  comeFromAdminPanel () {
    const adminEmail = this.getUser().adminEmail;

    return adminEmail !== null;
  }

  getUserEmail () {
    return this.getUser().userEmail;
  }

  getSupplierId () {
    return this.getUser().supplierId;
  }

  getStatus () {
    return this.getUser().supplierStatus;
  }

  getSellerTags () {
    return this.getUser().sellerTags;
  }

  hasTag (tagId) {
    return this.getSellerTags().some(tag => tag.tagId === tagId);
  }

  isStoreBased () {
    return window.user.storeBaseEnabled;
  }

  isActive () {
    return this.getStatus() === 'ACTIVE';
  }

  isMaster () {
    return this.getUser().isMaster();
  }

  isPhoneVerified () {
    return this.getUser().phoneVerified;
  }

  isMeal () {
    return this.getUser().mealSeller;
  }

  isMarket () {
    return this.getUser().saleType === 'MARKET';
  }
}

export default new SupplierService();
